module.exports = __webpack_public_path__ + "public/SiteIcons/shareFacebook.svg?9fea9068";